// iConnect — Banner service-area map (flexi-iconnect-banner.php)
// Requires GSAP to be loaded before this file.
//
// Intro: land slides in, suburbs pop in rippling outward from the current
// suburb, then a target ring "locks on" to it. Afterwards the target keeps
// turning, ripples radiate from the suburb and a pulse keeps travelling the
// route from the Mandurah hub to it — help on its way.

document.querySelectorAll('.iconnect-banner__map').forEach((map) => {
    const svg  = map.querySelector('.iconnect-sam__svg');
    const here = svg.querySelector('.iconnect-sam__loc.is-current');
    if (!here) return;

    const hub    = svg.querySelector('.iconnect-sam__loc--hub');
    const pulse  = svg.querySelector('.iconnect-sam__pulse');
    const others = [...svg.querySelectorAll('.iconnect-sam__loc:not(.is-current)')];
    const dist   = (loc) => Math.hypot(loc.dataset.x - here.dataset.x, loc.dataset.y - here.dataset.y);
    const maxDist = Math.max(...others.map(dist));
    const delayFor = (i, el) => 0.3 + (dist(el.closest('.iconnect-sam__loc')) / maxDist) * 1.1;

    gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
        const target = here.querySelector('.iconnect-sam__target');
        const ring   = here.querySelector('.iconnect-sam__ring');
        const route  = svg.querySelector('.iconnect-sam__route.is-current');

        // Pulse from the hub to the current suburb, on repeat (none when current is the hub).
        const dispatch = () => {
            if (here === hub) return;
            gsap.timeline({ repeat: -1, repeatDelay: 1.2 })
                .set(pulse, { attr: { cx: hub.dataset.x, cy: hub.dataset.y }, opacity: 1 })
                .to(pulse, { attr: { cx: here.dataset.x, cy: here.dataset.y }, duration: 0.6 + dist(hub) / 300, ease: 'power2.inOut' })
                .set(pulse, { opacity: 0 })
                .fromTo(here.querySelector('.iconnect-sam__dot'), { scale: 1 }, { scale: 1.8, duration: 0.2, yoyo: true, repeat: 1, ease: 'power2.out', transformOrigin: '50% 50%' }, '<');
        };

        const intro = gsap.timeline({ onComplete: dispatch })
            .from(svg.querySelector('.iconnect-sam__land'), { opacity: 0, x: 40, duration: 1, ease: 'power2.out' }, 0)
            .from(svg.querySelectorAll('.iconnect-sam__estuary'), { opacity: 0, duration: 1 }, 0.3)
            .from(others.flatMap((loc) => [...loc.querySelectorAll('.iconnect-sam__dot, .iconnect-sam__ring')]),
                { scale: 0, duration: 0.4, ease: 'back.out(3)', transformOrigin: '50% 50%', delay: delayFor }, 0)
            .from(others.map((loc) => loc.querySelector('.iconnect-sam__label')),
                { opacity: 0, duration: 0.4, delay: (i, el) => delayFor(i, el) + 0.05 }, 0)
            // Lock-on: target closes in from wide and faint, rings and dot snap in.
            .fromTo(target, { attr: { r: 90 }, opacity: 0 }, { attr: { r: 22 }, opacity: 1, duration: 0.9, ease: 'expo.out' }, 1.3)
            .from([ring, here.querySelector('.iconnect-sam__dot')], { scale: 0, duration: 0.5, ease: 'back.out(3)', transformOrigin: '50% 50%' }, 1.7)
            .from(here.querySelector('.iconnect-sam__label'), { opacity: 0, x: here.querySelector('.iconnect-sam__label').getAttribute('text-anchor') === 'end' ? 12 : -12, duration: 0.5 }, 1.8);

        if (route) {
            intro.fromTo(route, { strokeDasharray: 1, strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: 0.8, ease: 'power1.inOut', clearProps: 'strokeDasharray,strokeDashoffset' }, 1.9);
        }

        gsap.to(target, { rotation: 360, svgOrigin: '0 0', duration: 14, ease: 'none', repeat: -1 });

        gsap.fromTo(here.querySelectorAll('.iconnect-sam__ripple'),
            { attr: { r: 13 }, opacity: 0.8 },
            { attr: { r: 52 }, opacity: 0, duration: 2.6, ease: 'power1.out', repeat: -1, stagger: 1.3, delay: 2.2 });

        gsap.to(ring, { attr: { r: 16 }, duration: 1.3, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 2.2 });
    });
});
